<template>
    <el-container style="height: 100%;">
      <el-header style="text-align: left;background-color: whitesmoke;">
        <div style="width: 100%;height:55px;border: 0px blue solid;">
          <div style="width:60%;float: left;font-size: 20px;">郑记面条后台管理<span id="cnzz_box" style="display: none;"></span></div>
          <div style="width:40%;float: right;font-size: 15px;text-align: right;">
            <div style="margin-right: 20px;height: 60px;overflow: hidden;">
              <el-dropdown>
                <i class="el-icon-setting" style="margin-left: 15px;margin-right: 15px;font-size: 20px;"></i>
                 <el-dropdown-menu slot="dropdown">
                   <el-dropdown-item><a href="javascript:;" style="color: #000000;" @click="ADDTabPage('个人设置','UpdateInfor')">个人设置</a></el-dropdown-item>
                   <el-dropdown-item><a href="javascript:;" @click="openUPpass" style="color: #000000;">密码修改</a></el-dropdown-item>
                   <el-dropdown-item><a href="javascript:;" @click="exitLogin" style="color: #000000;">退出</a></el-dropdown-item>
                 </el-dropdown-menu>
               </el-dropdown>
               <span>欢迎你，{{AdminInfor.name}}</span>
            </div>
          </div>
        </div>
      </el-header>
      <el-container>
        <el-aside width="200px" style="display: block;position: absolute;left: 0;top: 58px;bottom: 0;" v-loading="loading">
            <el-menu :default-active="activeIndex" :router="true" :unique-opened="true">
              <el-menu-item index="" @click="ADDTabPage(bb.name,bb.url_name,bb.url)" v-for="bb in treelist" :key="bb.id" v-if="bb.list.length<=0">
                <i :class="bb.icon"></i>
                <span slot="title">{{bb.name}}</span>
              </el-menu-item>
              <el-submenu :index="bb.id" v-for="(bb,index) in treelist" :key="bb.id" v-if="bb.list.length>0">
                <template slot="title"><i :class="bb.icon"></i>{{bb.name}}</template>
                  <el-menu-item index="" @click="ADDTabPage(aa.name,aa.url_name,bb.url)" v-for="aa in bb.list" :key="aa.id">{{aa.name}}</el-menu-item>
              </el-submenu>
            </el-menu>
          </el-aside>
        <el-main>
          <div class="bodymain">
            <el-tabs v-model="editableTabsValue" type="card" @edit="handleTabsEdit">
              <el-tab-pane
                :key="item.name"
                v-for="(item, index) in editableTabs"
                :label="item.title"
                :name="item.name"
                :closable="item.close"
              >
                <component @parentHandle="PDHTAdmin_types" :is="item.content" :url="item.url"></component>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-main>
      </el-container>
      <!--黑幕遮挡-->
      <div class="zhedang" id="zhedang"></div>
      <div class="zhedang1" id="zhedang1"></div>
      <!--修改密码-->
      <div class="logindiv" id="UpdatePassForm">
        <div class="loginForm">
          <div style="width: 100%;height: 40px;background-color: #2d2d2d;margin: 0 auto;">
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
              密码修改
            </span>
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
              <a href="javascript:;" @click="closeUPpass">
                <i class="el-icon-close"></i>
              </a>
            </span>
          </div>
          <div style="width: 300px;margin: 0 auto;">
            <el-form :model="UpdateForm" style="margin-top: 30px;">
              <el-form-item prop="name">
                <el-input type="text" v-model="UpdateForm.oldpass" show-password placeholder="初始密码"></el-input>
              </el-form-item>
              <el-form-item prop="name">
                <el-input type="text" v-model="UpdateForm.pass" show-password placeholder="新密码"></el-input>
              </el-form-item>
              <el-form-item prop="phone">
                <el-input type="text" v-model="UpdateForm.repass" show-password placeholder="确认密码"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="loading" style="width: 300px;" @click="updateMyPass">保存</el-button>
              </el-form-item>
            </el-form>
          </div>
          <br>
        </div>
      </div>
    </el-container>
</template>

<script>
  import $ from 'jquery'
  import Text from '@/admin/views/index/Text'//首页通知页
  import UserList from '@/admin/views/users/userList'//用户列表
  import Report from '@/admin/views/index/Report'//报表
  import Authentication from '@/admin/views/authentication/Authentication'//商户认证列表
  import Category from '@/admin/views/goods/Category'//商品类别
  import Univalence from '@/admin/views/goods/Univalence'//自定义单价
  import GoodsList from '@/admin/views/goods/GoodsList'//商品列表
  import OrderList from '@/admin/views/order/OrderList'//订单查看
  import AConsulationList from '@/admin/views/consulation_admin/AConsulationList'//订单咨询
  import Liuyan from '@/admin/views/massage/Liuyan'//留言管理
  import APP_Feedback from '@/admin/views/massage/APP_Feedback'//APP反馈
  import Notice from '@/admin/views/notice/Notice'//前台通知
  import A_notice from '@/admin/views/system/A_notice'//后台通知
  import Lunbo from '@/admin/views/system/Lunbo'//首页展示
  import OrderConfirm from '@/admin/views/system/OrderConfirm'//下单管理
  import TimeTask from '@/admin/views/time/TimeTask'//定时任务
  import Download from '@/admin/views/system/Download'//下载管理
  import About_Our from '@/admin/views/system/About_Our'//关于我们
  import Logs from '@/admin/views/logs/Logs'//管理日志
  import SystemA from '@/admin/views/systemAdmin/SystemA'//管理员管理
  import Admin_Type from '@/admin/views/systemAdmin/Admin_Type'//权限管理
  import People from '@/admin/views/systemAdmin/People'//人员管理
  import UpdateInfor from '@/admin/views/update/UpdateInfor'//个人信息
  import Swagger from '@/admin/views/swagger/Swagger'//接口信息
  import Agreement from '@/admin/views/system/Agreement'//协议信息
  import SystemType from '@/admin/views/system/SystemType'//系统状态
  import TreeManage from '@/admin/views/system/TreeManage'//树形管理
  import IframeVue from '@/admin/views/A_zujian/IframeVue'//外部网页

  import RQEWMSC from '@/admin/views/NMRQEWM/RQEWMSC.vue'//南明入群二维码
  //
  import {commonAPI} from '@/api/commonAPI'
export default {
  components: {
    'text-bar': Text,
    'userlist-bar': UserList,
    'Report' : Report ,
    'Authentication' : Authentication ,
    'Category' : Category ,
    'Univalence' : Univalence ,
    'GoodsList' : GoodsList ,
    'OrderList' : OrderList ,
    'AConsulationList' : AConsulationList ,
    'Liuyan' : Liuyan ,
    'APP_Feedback' : APP_Feedback ,
    'Notice' : Notice ,
    'A_notice' : A_notice ,
    'Lunbo' : Lunbo ,
    'OrderConfirm' : OrderConfirm ,
    'Download' : Download ,
    'About_Our' : About_Our ,
    'Logs' : Logs ,
    'SystemA' : SystemA ,
    'Admin_Type' : Admin_Type,
    'People' : People ,
    'UpdateInfor' : UpdateInfor,
    'TimeTask' : TimeTask,
    'Swagger' : Swagger,
    'Agreement' : Agreement,
    'SystemType' : SystemType,
    'TreeManage' : TreeManage,
    'IframeVue' : IframeVue,

    'RQEWMSC':RQEWMSC,
  },
  created () {
      this.loading=true;
      //在页面加载时读取sessionStorage里的状态信息
      if (sessionStorage.getItem("Astore")) {
        //console.log("加载："+sessionStorage.getItem("store"))
        let data=JSON.parse(sessionStorage.getItem("Astore"))
        this.$store.commit({
          type:'changeAdminInfor',
          a_token:data.a_token,
          a_id:data.a_id,
          Aname:data.Aname,
          Aphoto:data.Aphoto,
          a_type:data.a_type,
        });
        sessionStorage.removeItem("Atoken");//口令
        sessionStorage.setItem("Atoken",this.$store.state.a_token)//口令
        sessionStorage.removeItem("Astore");
      }
    },
  data () {
    return {
      adminsalt:'havetorich',//管理员密码后缀
      UpdateForm:{
        oldpass:'',
        pass:'',
        repass:'',
      },
      loading:false,
      activeIndex: this.$route.path,
      //管理员相关信息
      AdminInfor:{
        id:'',
        name:'',
        photo:'',
        type:'',
        admin_type:'',
        admin_id:'',
      },

      editableTabsValue: '1',
      editableTabs: [{
        title: '主页',
        name: '1',
        close:false,
        content: Text
      }],
      tabIndex: 2,
      treelist:'',
    }
  },

  //页面重新渲染
  computed:{
    keys(){
      return this.$route.name?this.$route.name+ +new Date():this.$route+ +new Date()
    }
  },

  //页面开启时执行
  mounted(){
    this.judgeLogin()
  },
  //方法
  methods: {
    //cnzz
    queryTree(){
      commonAPI('queryTreeList',this.AdminInfor).then(res => {
        let data=res.data.data.rows
        //console.log(res.data.data.rows);
        this.treelist=data;
      }).catch(error=>{
        this.loading = false;
        this.$notify({//这里采用element ui的一个错误显示效果模板
          title: '提示',
          message: error.message,
          position: 'bottom-right',
          type: 'error'
        });
        })
    },
    /**
    //设置cookie
     setCookie(day) {
     var exdate=new Date();//获取时间
     exdate.setTime(exdate.getTime() + 24*60*60*1000*1);//保存的天数
     //字符串拼接cookie
     window.document.cookie="editableTabs"+"=+="+this.editableTabs+";path=/";
     },
    //读取cookie
    getCookie:function () {
     if (document.cookie.length>0) {
      var arr=document.cookie.split('; ');//这里显示的格式需要切割一下自己可输出看下
      for(var i=0;i<arr.length;i++){
       var arr2=arr[i].split('=+=');//再次切割
       //判断查找相对应的值
       if(arr2[0]=='editableTabs'){
        this.editableTabs=arr2[1];//保存到保存数据的地方
       }
      }
     }
    },
    */
    //添加新标签页面
    ADDTabPage(Title,Contents,urls){
      let PD_I=0;
      let PD=0;
      for(let i=0;i<this.editableTabs.length;i++){
        if(Title==this.editableTabs[i].title){
          PD_I=1;
          PD=i;
          break;
        }
      }
      if(PD_I==1){
        this.editableTabsValue=this.editableTabs[PD].name;
        return false;
      }
      const thisComp = Contents;
      let newTabName = ++this.tabIndex + '';
      this.editableTabs.push({
        title: Title,
        name: newTabName,
        close:true,
        content: thisComp,
        url:urls
      });
      this.editableTabsValue = newTabName;
      //this.setCookie(1);
    },
    handleTabsEdit(targetName, action) {
      if (action === 'remove') {
        let tabs = this.editableTabs;
        let activeName = this.editableTabsValue;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
              }
            }
          });
        }
        this.editableTabsValue = activeName;
        this.editableTabs = tabs.filter(tab => tab.name !== targetName);
      }
    },
    //判定是否拥有此页面权限信息
    PDHTAdmin_types(date){//data为当前页面最高权限信息
      if(date=='updateInformation'){
        this.judgeLogin();
      }else{
        /**
        let type=this.$store.state.a_type;
        if(date*1<=type*1){
          this.exitLogin()
        }
        */
      }
    },
    //保存修改密码
    updateMyPass(){
      if(this.UpdateForm.pass.length<8){
        this.$notify({//这里采用element ui的一个错误显示效果模板
          title: '提示',
          message: "密码长度不得小于8位",
          position: 'bottom-right',
          type: 'error'
        });
        return false;
      }
      if(this.UpdateForm.pass==''||this.UpdateForm.repass==''||this.UpdateForm.oldpass==''){
        this.$notify({//这里采用element ui的一个错误显示效果模板
          title: '提示',
          message: "信息未填写完整!",
          position: 'bottom-right',
          type: 'error'
        });
        return false;
      }
      if(this.UpdateForm.pass!==this.UpdateForm.repass){
        this.$notify({//这里采用element ui的一个错误显示效果模板
          title: '提示',
          message: "两次密码不一致！",
          position: 'bottom-right',
          type: 'error'
        });
        return false;
      }
      let pass1=this.UpdateForm.pass;
      let pass2=this.UpdateForm.repass;
      let pass3=this.UpdateForm.oldpass;
      this.UpdateForm.oldpass=this.$md5(this.UpdateForm.oldpass+this.adminsalt);
      this.UpdateForm.password=this.$md5(this.UpdateForm.pass+this.adminsalt);
      this.UpdateForm.pass=this.$md5(this.UpdateForm.pass+this.adminsalt);
      this.UpdateForm.repass=this.$md5(this.UpdateForm.repass+this.adminsalt);
      this.UpdateForm.id=this.$store.state.a_id;
      commonAPI('updateMyPassword',this.UpdateForm).then(res => {
        let data = res.data;
        //console.log(res.data.rows);
        if(this.response.response(data)){
          this.closeUPpass();
        }else{
          this.UpdateForm.pass=pass1
          this.UpdateForm.repass=pass2
          this.UpdateForm.oldpass=pass3
        }
      }).catch(error=>{
        this.loading = false;
        this.$notify({//这里采用element ui的一个错误显示效果模板
          title: '提示',
          message: error.message,
          position: 'bottom-right',
          type: 'error'
        });
        })
    },
    //打开修改密码界面
    openUPpass(){
      document.getElementById('UpdatePassForm').style.display='block';
      document.getElementById('zhedang').style.display='block';
    },
    //关闭修改密码界面
    closeUPpass(){
      this.UpdateForm.oldpass='';
      this.UpdateForm.pass='';
      this.UpdateForm.repass='';
      document.getElementById('UpdatePassForm').style.display='none';
      document.getElementById('zhedang').style.display='none';
    },
    //获取信息方法
    judgeLogin(){
      if (this.$store.state.a_id.length>0) {
        this.AdminInfor.id=this.$store.state.a_id;
      }else{
        sessionStorage.removeItem("token");
        //console.log("No Logining!!");
      }
      if(this.AdminInfor.id.length>0){
        commonAPI('queryAdmininfor', this.AdminInfor).then(res => {
          let data=res.data.data[0];
          this.AdminInfor.id=data.id;
          this.AdminInfor.admin_id=data.id;
          this.AdminInfor.name=data.name;
          this.AdminInfor.photo=data.photo;
          this.AdminInfor.type=data.type;
          this.AdminInfor.admin_type=data.type;
          this.saveLogining();
          this.queryTree();
          this.loading=false;
        });
      }else{
        this.gotothispage('/Alogin');
      }
    },
    //登录信息的存储
    saveLogining(){
      sessionStorage.removeItem("Astore");
      sessionStorage.removeItem("Atoken");//口令
      if(this.$store.state.u_id.length<=0){//只执行一次
        this.$store.commit({
          type:'changeAdminInfor',
          a_token:this.$store.state.a_token,
          a_id:this.AdminInfor.id,
          a_type:this.AdminInfor.type,
        });
      }else{
        this.$store.commit({
          type:'change_Admin_Name_Photo',
          Aname:this.AdminInfor.Aname,
          Aphoto:this.AdminInfor.Aphoto
        });
      }
      sessionStorage.setItem("Atoken",this.$store.state.a_token)//口令
      sessionStorage.setItem("Astore",JSON.stringify(this.$store.state))
    },
    //退出登录
    exitLogin(){
      sessionStorage.removeItem("Astore");
      sessionStorage.removeItem("Atoken");
      this.AdminInfor.id='';
      this.AdminInfor.name='';
      this.AdminInfor.photo='';
      //跳转
      this.gotothispage('/Alogin');
      this.$router.go(0);
    },
    //更换页签
    gotothispage(data){
      this.$router.push({path: data});
    },
  }
}
</script>

<style scoped>
  /deep/ .el-tabs__content{
    padding: 5px;
    overflow-y: scroll;
    height: calc(815px);
  }
  /deep/ .el-tabs__content::-webkit-scrollbar{
    display: none;
  }

  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }

  .el-aside,
  .el-menu,
  .el-submenu,
  .el-menu-item {
    background-color: rgb(238, 241, 246);
  }

  .el-main{
    background-color: white;
    margin-left: 200px;
    max-height: 883px;
    padding: 0px;
  }

  body {
    height: 100%;
    margin: 0px;
  }

  .el-dropdown{
    text-align: center;
    height: 40px;
  }

  .bodymain{
    width:100%;
    max-height: calc(883px - 0px);
    overflow: hidden;
  }

  /**滚动条样式*/
  .bodymain::-webkit-scrollbar{
    width: 5px;
  }
  .bodymain::-webkit-scrollbar-thumb{
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: #535353;
  }
  .bodymain::-webkit-scrollbar-thumb{
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 10px;
    background: #EDEDED;
  }

  .titlename{
  width:188px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  word-break:keep-all;
  }

  /**遮挡css*/
  .zhedang{
  	position: fixed;
      top: 0;
      width: 100%;
      height: 100%;
      padding: 20px;
      border: 1px solid #ddd;
      background-color: #000;
      opacity: 0.5;
      z-index:15;
      overflow: auto;
      min-width:1200px;
      display: none;
  }
  .zhedang1{
  	position: fixed;
      top: 0;
      width: 100%;
      height: 100%;
      padding: 20px;
      border: 1px solid #ddd;
      background-color: #000;
      opacity: 0.5;
      z-index:2003;
      overflow: auto;
      min-width:1200px;
      display: none;
  }
  /**登录框架*/
  .logindiv{
    position: fixed;
    top: 25%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    text-align: center;
    display: none;
  }
  .loginForm{
    margin: 0 auto;
    width: 550px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .loginForm a{
    color: #fff;
  }
  .loginForm a:hover{
    color: #d6d6d6;
  }


  .nav >>> .el-tabs__header .el-tabs__item:nth-child(1) span{
    display: none;
  }
  .nav >>> .el-tabs__header .el-tabs__item:nth-child(2) span{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/admin/views/index/index.vue